/**
 * 403 page shown when a non-teacher tries to enter `/teacher/*`. The page
 * MUST render even when there is no session, so it does not call
 * `useSession()`.
 */

import { Link } from 'react-router-dom';
import type { UiRole } from '../api/types';

export interface ForbiddenProps {
  role?: UiRole;
}

export function Forbidden({ role }: ForbiddenProps) {
  return (
    <main
      className="page page--centered"
      role="main"
      data-testid="forbidden-page"
    >
      <h1>403 — Access denied</h1>
      <p>
        Your role <code>{role ?? 'unknown'}</code> is not allowed in the teacher
        area.
      </p>
      <p>
        If you reached this page by mistake, sign in with a teacher account.
      </p>
      <p>
        <Link to="/login" className="btn">
          Back to sign in
        </Link>
      </p>
    </main>
  );
}
